var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1167({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.79,10.21a3.13,3.13,0,0,0,3.93.4L5.39,6.28A3.13,3.13,0,0,0,5.79,10.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.28,5.39l4.33,4.33A3.13,3.13,0,0,0,6.28,5.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,1a7,7,0,1,0,7,7A7,7,0,0,0,8,1Zm3.09,10.09a4.37,4.37,0,1,1,0-6.18A4.36,4.36,0,0,1,11.09,11.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1167);
export default __webpack_public_path__ + "static/media/Symbolpack_1_167.73ce16267d81b084789ada1c9e10d423.svg";
export { ForwardRef as ReactComponent };